export default function checkIsEmptyGuid(guid) {
  // Check if the GUID is null, undefined, or an empty string
  return !guid || guid === '00000000-0000-0000-0000-000000000000';
}
